import React from 'react'
import { Button, Col, Row } from 'react-bootstrap';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';
import { BsStarHalf } from 'react-icons/bs';
import ReactStars from "react-rating-stars-component";
import UseRatePost from "./../../CustomHooks/Reviews/UseRatePost"
const RatePost = ({ IsLogin }) => {
  const [onChangeReviewValue, rateText, onChangeRateText, Submit, ValidateRateText] = UseRatePost();
 
  const setting = {
    size: 20,
    count: 5,
    color: "#f8bc36",
    activeColor: "#f8bc36",
    value: 0,
    a11y: true,
    isHalf: true,
    emptyIcon: <AiOutlineStar />,
    halfIcon: <BsStarHalf />,
    filledIcon: <AiFillStar />,
    onChange: newValue => {
      onChangeReviewValue(newValue)
    }
  };
  return (
    <>
      <Row>
        <Col>
          <ReactStars {...setting}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <textarea
            value={rateText}
            onChange={onChangeRateText}
            onBlur={ValidateRateText}
            className="form-control p-2 mt-3 h-120px"
            rows="2"
            cols="20"
            placeholder="Type Your Comment ...."
          />
          <div className=" d-flex justify-content-end al">
            <Button className='orange-bg h-50px mt-3' onClick={Submit}> Add Your Comment</Button>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default RatePost
